/**
 * EvalsConfigFooter: the footer under each form that edits a team's
 * customer config row (useEvalsConfigForm). Both pages save the same
 * row, so they end with the same buttons.
 */

import { SettingsFormFooter } from '@/components/settings/SettingsFormFooter'
import { Button } from '@/components/ui/button'
import type { EvalsConfigFormState } from '@/hooks/useEvalsConfigForm'

export function EvalsConfigFooter({
  state,
}: {
  state: EvalsConfigFormState
}): React.JSX.Element {
  return (
    <SettingsFormFooter dirty={state.dirty} error={state.error}>
      <Button
        type="button"
        variant="outline"
        disabled={!state.dirty || state.pending}
        onClick={state.discard}
      >
        Discard
      </Button>
      <Button type="submit" disabled={!state.canSubmit}>
        {state.creates ? 'Create' : 'Save'}
      </Button>
    </SettingsFormFooter>
  )
}
